import React from "react";

import colors from "../../../tailwindcss/colors.tailwind";
import themeConfig from "../../../config/theme.config";

const LogoTemplate = (props) => {
  const { ...rest } = props;
  return (
    <svg width="138" height="30" viewBox="0 0 138 30" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <g clip-path="url(#clip0_360_458)">
        <path d="M35.4265 30V0L30.6557 0V30H35.4265Z" fill="#FEBA06" />
        <path d="M25.2067 30L25.2067 0L20.4359 0V30H25.2067Z" fill="#FEBA06" />
        <path d="M14.9868 19.8937L14.9868 0L10.2161 0V19.8937H14.9868Z" fill="currentColor" />
        <path d="M4.77457 30L4.77457 0L0.00379419 0L0.00379419 30H4.77457Z" fill="currentColor" />
        <path d="M45.6425 30V0L40.8718 0V30H45.6425Z" fill="#FEBA06" />
        <path
          d="M56.1958 12.8213V0.288818H62.759C64.1421 0.288818 65.2675 0.693818 66.0974 1.48882C66.9272 2.28382 67.3478 3.34882 67.3478 4.65382C67.3478 5.95882 66.9045 7.10632 66.0329 7.92007C65.1576 8.73757 63.964 9.15007 62.4899 9.15007H59.5835V12.8176H56.1958V12.8213ZM59.5835 6.56632H62.0428C62.5998 6.56632 63.0735 6.39757 63.4448 6.06382C63.8238 5.72632 64.0132 5.28382 64.0132 4.74757C64.0132 4.21132 63.82 3.81382 63.441 3.48757C63.0697 3.16882 62.596 3.00382 62.039 3.00382H59.5797V6.56257L59.5835 6.56632Z"
          fill="currentColor"
        />
        <path
          d="M77.6056 12.8213L76.8856 10.8638H71.5275L70.7886 12.8213H67.1584L72.2664 0.288818H76.1543L81.2585 12.8213H77.6094H77.6056ZM72.5506 8.10382H75.8852L74.2293 3.59257L72.5506 8.10382Z"
          fill="currentColor"
        />
        <path
          d="M85.6806 12.8213L80.368 0.288818H84.1535L87.4124 8.25007L90.6484 0.288818H94.434L89.1213 12.8213H85.6806Z"
          fill="currentColor"
        />
        <path d="M99.1783 0.288818H95.7906V12.8213H99.1783V0.288818Z" fill="currentColor" />
        <path
          d="M111.278 12.8213L105.056 5.92507V12.8213H101.668V0.288818H104.487L110.709 7.42507V0.288818H114.12V12.8213H111.278Z"
          fill="currentColor"
        />
        <path
          d="M122.983 13.1099C121.046 13.1099 119.391 12.4687 118.064 11.2087C116.742 9.94866 116.071 8.38491 116.071 6.55866C116.071 4.73241 116.742 3.16866 118.064 1.90491C119.391 0.641162 121.039 0.00366211 122.964 0.00366211C124.464 0.00366211 125.802 0.337412 126.935 0.997412C128.004 1.61991 128.758 2.48616 129.186 3.57741L125.711 4.43991C125.158 3.47616 124.233 2.98866 122.968 2.98866C121.967 2.98866 121.13 3.33366 120.478 4.00866C119.83 4.68366 119.5 5.54241 119.5 6.55491C119.5 7.56741 119.838 8.42616 120.497 9.10116C121.16 9.77991 122.013 10.1212 123.025 10.1212C124.472 10.1212 125.488 9.54741 126.048 8.41491L126.166 8.17491H122.725V5.47491H129.637C129.682 6.08241 129.701 6.44241 129.701 6.57366C129.701 8.48991 129.069 10.0724 127.822 11.2837C126.571 12.4949 124.946 13.1062 122.983 13.1062V13.1099Z"
          fill="currentColor"
        />
        <path
          d="M68.0527 30V24.3488L67.7306 24.2738L64.8848 30H62.6718L59.826 24.3113L59.5077 24.3863V30H56.1958V17.4675H59.8639L63.7669 24.6825L67.6927 17.4675H71.3608V30H68.0527Z"
          fill="currentColor"
        />
        <path
          d="M83.1304 30L82.4142 28.0425H77.0561L76.3172 30H72.687L77.7912 17.4675H81.6791L86.7833 30H83.1342H83.1304ZM78.0754 25.2825H81.4101L79.7541 20.7713L78.0754 25.2825Z"
          fill="currentColor"
        />
        <path
          d="M95.8133 30L92.2438 25.89H91.4935V30H88.1058V17.4675H94.866C96.2112 17.4675 97.3139 17.8538 98.1362 18.6113C98.9547 19.3688 99.3715 20.3813 99.3715 21.6188C99.3715 22.6013 99.1025 23.4563 98.572 24.1613C98.0415 24.8625 97.2988 25.365 96.3666 25.6463L96.1203 25.7213L99.8528 29.9963H95.8171L95.8133 30ZM91.4935 23.3063H94.165C94.722 23.3063 95.1767 23.16 95.5178 22.8713C95.8664 22.575 96.0445 22.1888 96.0445 21.7163C96.0445 21.2438 95.8664 20.88 95.5178 20.5988C95.1767 20.325 94.7258 20.1863 94.1688 20.1863H91.4973V23.3063H91.4935Z"
          fill="currentColor"
        />
        <path
          d="M109.409 30L105.779 25.4663H104.87V30H101.482V17.4675H104.87V22.3275H105.586L109.447 17.4675H113.426L108.489 23.775L113.779 30H109.409Z"
          fill="currentColor"
        />
        <path
          d="M115.15 30V17.4675H125.078V20.2463H118.538V22.4813H124.555V24.9675H118.538V27.2213H125.158V30H115.15Z"
          fill="currentColor"
        />
        <path d="M130.516 30V20.3025H126.443V17.4675H138V20.3025H133.926V30H130.516Z" fill="currentColor" />
      </g>
      <defs>
        <clipPath id="clip0_360_458">
          <rect width="138" height="30" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default LogoTemplate;
